import { useAuthStore } from '@avanta/shared/stores/auth';
import { QueryClient, QueryClientProvider as Provider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type ReactElement, type PropsWithChildren } from 'react';
import { useSuspenseFetchUser } from 'hooks/useSuspenseFetchUser';

const DEVTOOLS_ENABLED = import.meta.env.VITE_REACT_QUERY_DEV_TOOLS === 'true';

export const queryClient = new QueryClient();

const SuspenseFetching = (): null => {
  useSuspenseFetchUser();
  return null;
};

export const QueryClientProvider = ({ children }: PropsWithChildren): ReactElement => {
  const token = useAuthStore(state => state.token());

  return (
    <Provider client={queryClient}>
      {DEVTOOLS_ENABLED && <ReactQueryDevtools />}
      {token && <SuspenseFetching />}
      {children}
    </Provider>
  );
};
